import React from 'react'
import { TextImageBox as OriginalTextImageBox } from '@next-nx/shared-ui/organisms'
import { TextImageBoxSettings } from './TextImageBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  imagePos: 'left',
  imageLabel: '',
  imageLabelVariant: 'green',
  src: 'https://via.placeholder.com/287x215.png',
  image: '',
  titleSize: 'md',
  bgVariant: '',
  ctaVariant: 'primary',
  ctaLabel: '',
  link: '',
  pageLink: '',
  openNewTab: false,
}

export const TextImageBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { 
      imagePos,
      imageLabel,
      imageLabelVariant,
      src,
      image,
      titleSize,
      bgVariant,
      ctaVariant,
      ctaLabel,
      link,
      pageLink,
      openNewTab,
    } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-text-image-box ' + props.className}
      >
        <OriginalTextImageBox
          key={image ? image : src}
          item={{
            name: children.props.children[0],
            description: children.props.children[1],
            ctaLabel: ctaLabel,
            url: pageLink || link || '#',
            image: image ? image : src,
            blank: openNewTab
          }}
          bgVariant={bgVariant}
          titleSize={titleSize}
          ctaVariant={ctaVariant}
          imagePos={imagePos}
          imageLabel={imageLabel}
          imageLabelVariant={imageLabelVariant}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

TextImageBox.craft = withCraft({
  name: 'TextImageBox',
  defaultProps: defaultProps,
  settings: TextImageBoxSettings,
});
